import { useEffect } from 'react';

export const useClickAway = (ref, callback, awayClick) => {
  useEffect(() => {
    if (!awayClick) {
      return;
    }
    const listener = (event) => {
      if (ref.current?.contains(event.target)) {
        return;
      }

      callback(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, callback, awayClick]);
};
